  <!-- <div class="form-group"> -->
    <label *ngIf="label" [for]="id" class="mb-2 global-form-field">{{ label | translate }} <span class="text-danger fw-bold" *ngIf="required">*</span></label>

    <ng-container *ngIf="loading; else inputTemplate">
      <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5px', height: '35px' }" />
    </ng-container>

    <ng-template #inputTemplate>
      <input
          [type]="type"
          [id]="id"
          [name]="name"
          [ngModel]="value" 
          (ngModelChange)="onChange($event)"
          (input)="onNativeInput($event)"
          [disabled]="disabled"
          [required]="required"
          [min]="min"
          [max]="max"
          [maxlength]="maxlength"
          [minlength]="minlength" 
          [pattern]="isPhoneNumber ? '/^[0-9\u1040-\u1049]*$/': ''"
          [placeholder]="placeholder | translate"
          [ngClass]="className"
          class="form-control global-form-field main-inputbox" style="line-height: 1.62;"
          (keypress)="onKeypress($event)"
          autocomplete="off"
          #inputModel="ngModel"
          [email]="type === 'email'"
          (blur)="onBlur($event)"/>

      <div class="error" *ngIf="className == 'error-input'">
        <span>This mobile number is already registered.</span>
      </div>

      <div class="error" *ngIf="className == 'warning-input'">
        <span>Please verify your mobile number to check if it is already registered.</span>
      </div>
      <div *ngIf="amountLow" class="text-danger mt-3">
        <span>{{ amountLow }}</span>
      </div>
      <div *ngIf="inputModel.invalid && inputModel.touched && inputModel.errors" class="error">
        <span *ngIf="inputModel.errors['required']">{{validateReqMsg}}</span>
        <span *ngIf="inputModel.errors['minlength']">Minimum length is {{ minlength }} characters.</span>
        <span *ngIf="inputModel.errors['maxlength']">Maximum length is {{ maxlength }} characters.</span>
        <span *ngIf="inputModel.errors['pattern']">Phone Number must be start with 09.</span>
        <span *ngIf="inputModel.errors['email']"> Invalid email format.</span>
      </div>
      
    </ng-template>

    
  